import {Injectable} from '@angular/core';
import {TapticEngine} from '@ionic-native/taptic-engine/ngx';
import {Platform} from '@ionic/angular';
import {DeviceFeedback} from '@ionic-native/device-feedback/ngx';

@Injectable({ providedIn: 'root' })
export class DeviceFeedbackProvider {
    constructor(private platform: Platform, private ios: TapticEngine, private android: DeviceFeedback) { }
    
    async tap() {
        await this.platform.ready();
        if (this.platform.is('cordova')) {
            if (this.platform.is('android'))
                this.android.haptic(3);
            else if (this.platform.is('ios'))
                await this.ios.impact({ style: 'light' });
        }
    }

    async longPress() {
        await this.platform.ready();
        if (this.platform.is('cordova')) {
            if (this.platform.is('android'))
                this.android.haptic(0);
            else if (this.platform.is('ios'))
                await this.ios.impact({ style: 'heavy' });
        }
    }
}
